import "globals";

(function ($, window, document, PageLoadedQueue) {
    window.PageLoadedQueue.addFunction(function () {
        if ($.prototype.lightGallery) {
            $(".light-gallery").lightGallery({
                download: false,
                thumbnail: true,
                autoplayFirstVideo: false,
                autoplay: false,
            });
        }
    });

    $(".light-gallery").on("onAfterSlide.lg", function (event) {
        const videoElement = document.querySelector(".lg-current .lg-video");

        if (videoElement && videoElement.querySelector(".dsg-overlay-container") === null) {
            let dsgOverlayContainer = document.createElement("div");
            dsgOverlayContainer.classList.add("dsg-overlay-container");
            dsgOverlayContainer.innerHTML = _AVENCY_BASE_translations.dsgvoCompliance.privacyPolicyHint.video.replace(
                "{uri}",
                _AVENCY_BASE_pages.privacyPolicy
            );
            videoElement.appendChild(dsgOverlayContainer);
        }
    });
})(jQuery, window, document, window.PageLoadedQueue);
